var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.switchView
    ? _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: { sm: "12", md: "2", xs: "12", cols: "12" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "descricao",
                  attrs: { title: _vm.getTitleFor(_vm.ativo) }
                },
                [_c("span", [_vm._v(" " + _vm._s(_vm.getTitleFor(_vm.ativo)))])]
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: {
                sm: "12",
                md: "1",
                xs: "12",
                cols: "12",
                title: _vm.ativo.percentege * 100
              }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.percentageHelper.formatPercentage(
                        _vm.ativo.percentege
                      )
                    )
                  )
                ])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: { sm: "12", md: "2", xs: "12", cols: "12" }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [_vm._v(" " + _vm._s(_vm.ativo.emissor))])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: { sm: "12", md: "2", xs: "12", cols: "12" }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [_vm._v(" " + _vm._s(_vm.ativo.custodiante))])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: { sm: "12", md: "1", xs: "12", cols: "12" }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [_vm._v(_vm._s(_vm.ativo.liquidez) + " ")])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: { sm: "12", md: "2", xs: "12", cols: "12" }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.dateHelper.formatDate(_vm.ativo.vencimento)) +
                      " "
                  )
                ])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "col",
              attrs: {
                sm: "12",
                md: "2",
                xs: "12",
                cols: "12",
                title: _vm.ativo.value
              }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.currencyHelper.formatValue(_vm.ativo.value)) +
                      " "
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    : _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
            [
              _c(
                "div",
                {
                  staticClass: "descricao",
                  attrs: { title: _vm.getTitleFor(_vm.ativo) }
                },
                [_c("span", [_vm._v(" " + _vm._s(_vm.getTitleFor(_vm.ativo)))])]
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "coluna",
              attrs: { sm: "12", md: "1", xs: "12", title: _vm.ativo.value }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.currencyHelper.formatValue(_vm.ativo.value))
                  )
                ])
              ])
            ]
          ),
          _c(
            "v-col",
            { staticClass: "coluna", attrs: { sm: "12", md: "9", xs: "12" } },
            [
              _c(
                "div",
                { staticClass: "colunas" },
                [
                  _c(
                    "v-row",
                    { staticClass: "row-expansion-2" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.mesAtual * 100
                          }
                        },
                        [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.percentageHelper.formatPercentage(
                                        _vm.ativo.mesAtual
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.percent1 * 100
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.percentageHelper.formatPercentagePoints(
                                        _vm.ativo.percent1
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "2",
                            xs: "12",
                            title: _vm.ativo.valor1
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.currencyHelper.formatValue(
                                        _vm.ativo.valor1
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.dozeMeses * 100
                          }
                        },
                        [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.percentageHelper.formatPercentage(
                                        _vm.ativo.dozeMeses
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.percent2 * 100
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.percentageHelper.formatPercentagePoints(
                                        _vm.ativo.percent2
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "2",
                            xs: "12",
                            title: _vm.ativo.valor2
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bound
                                    ? "---"
                                    : _vm.currencyHelper.formatValue(
                                        _vm.ativo.valor2
                                      )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.desdeInicio * 100
                          }
                        },
                        [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.percentageHelper.formatPercentage(
                                    _vm.ativo.desdeInicio
                                  )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "1",
                            xs: "12",
                            title: _vm.ativo.percent3 * 100
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.percentageHelper.formatPercentagePoints(
                                    _vm.ativo.percent3
                                  )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "coluna-2",
                          attrs: {
                            sm: "12",
                            md: "2",
                            xs: "12",
                            title: _vm.ativo.valor3
                          }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currencyHelper.formatValue(
                                    _vm.ativo.valor3
                                  )
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }